import { isEmpty } from '../../utils/lodash';
import {
  ADMIN_PANEL_REQUEST,
  ADMIN_PANEL_SUCCESS,
  ADMIN_PANEL_FAILURE,
  ADMIN_DETAILS_REQUEST,
  ADMIN_DETAILS_FAILURE,
  ADMIN_DETAILS_CREATE_REQUEST,
  ADMIN_DETAILS_CREATE_SUCCESS,
  ADMIN_DETAILS_CREATE_FAILURE,
  ADMIN_DETAILS_UPADTE_REQUEST,
  ADMIN_DETAILS_UPADTE_SUCCESS,
  ADMIN_DETAILS_UPADTE_FAILURE,
  ADMIN_DETAILS_DELETE_REQUEST,
  ADMIN_DETAILS_DELETE_SUCCESS,
  ADMIN_DETAILS_DELETE_FAILURE,
  PRODUCT_ACCESS_REQUEST,
  PRODUCT_ACCESS_SUCCESS,
  PRODUCT_ACCESS_FAILURE,
  DIGITAL_ASSETS_SUCCESS,
  PRODUCT_INFO_SUCCESS,
  EXCLUSIVE_SUCCESS,
  HEADER_LINK_SUCCESS,
  UPLOAD_EIN_FILE_REQUEST,
  UPLOAD_EIN_FILE_FAILURE,
  UPLOAD_EIN_FILE_SUCCESS,
  CLEAR_MESSAGE,
  SAMPLE_DATA_REQUEST,
  SAMPLE_DATA_SUCCESS,
  SAMPLE_DATA_FAILURE,
  UPLOAD_ERROR_MESSAGE,
  UPLOAD_FILE_FAILURE,
  PUT_EIN_S3_URL_REQUEST,
  GET_ENLM_FEEDBACK_CSV_DATA_REQUEST,
  GET_ENLM_FEEDBACK_CSV_DATA_SUCCESS,
  GET_ENLM_FEEDBACK_CSV_DATA_FAILURE
} from './constants';
import I18n from '../../config/locales';

let initialState = {
  headerBarDetails: {
    same_for_all_tiers: false,
    tiers: [
      {
        name: 'platinum',
        banners: [
          {
            description: '',
            url: ''
          },
          {
            description: '',
            url: ''
          }
        ]
      },
      {
        name: 'gold',
        banners: [
          {
            description: '',
            url: ''
          },
          {
            description: '',
            url: ''
          }
        ]
      },
      {
        name: 'silver',
        banners: [
          {
            description: '',
            url: ''
          },
          {
            description: '',
            url: ''
          }
        ]
      }
    ]
  },
  digitalAssetsDetails: [],
  exclusiveDetails: [],
  productInfoDetails: [],
  productAccessList: '',
  loading: false,
  message: '',
  messageType: '',
  installerSetupHeaders: [],
  installerUpdateHeaders: [],
  installerSetupErrorList: [],
  installerSetupSuccessList: [],
  installerUpdateErrorList: [],
  installerUpdateSuccessList: [],
  enlmFeedbacksCsvData : ''
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case ADMIN_PANEL_REQUEST:
      return { ...state, loading: true };
    case ADMIN_PANEL_SUCCESS:
      return {
        ...state,
        headerBarDetails: isEmpty(action.headerBarDetails) ? initialState.headerBarDetails : action.headerBarDetails,
        digitalAssetsDetails: action.digitalAssetsDetails,
        exclusiveDetails: action.exclusiveDetails,
        productInfoDetails: action.productInfoDetails,
        loading: false
      };
    case ADMIN_PANEL_FAILURE:
      return {
        ...state,
        loading: false,
        message: I18n.t('message.failureMessageUpload'),
        messageType: 'error'
      };
    case ADMIN_DETAILS_REQUEST:
      return { ...state, loading: true };
    case ADMIN_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        message: action.error,
        messageType: 'error'
      };
    case HEADER_LINK_SUCCESS:
      return {
        ...state,
        headerBarDetails: action.headerBarDetails !== null ? action.headerBarDetails : state.headerBarDetails,
        loading: false,
        message: 'Success',
        messageType: 'success'
      };
    case DIGITAL_ASSETS_SUCCESS:
      return {
        ...state,
        digitalAssetsDetails: action.digitalAssetsDetails,
        loading: false,
        message: 'Success',
        messageType: 'success'
      };
    case PRODUCT_INFO_SUCCESS:
      return {
        ...state,
        productInfoDetails: action.productInfoDetails,
        loading: false,
        message: 'Success',
        messageType: 'success'
      };
    case EXCLUSIVE_SUCCESS:
      return {
        ...state,
        exclusiveDetails: action.exclusiveDetails,
        loading: false,
        message: 'Success',
        messageType: 'success'
      };
    case ADMIN_DETAILS_CREATE_REQUEST:
      return { ...state, loading: true };
    case ADMIN_DETAILS_CREATE_SUCCESS:
      return {
        ...state,
        loading: false,
        message: 'Success',
        messageType: 'success'
      };
    case ADMIN_DETAILS_CREATE_FAILURE:
      return {
        ...state,
        loading: false,
        message: action.error,
        messageType: 'error'
      };
    case ADMIN_DETAILS_UPADTE_REQUEST:
      return { ...state, loading: true };
    case ADMIN_DETAILS_UPADTE_SUCCESS:
      return {
        ...state,
        loading: false,
        message: 'Success',
        messageType: 'success'
      };
    case ADMIN_DETAILS_UPADTE_FAILURE:
      return {
        ...state,
        loading: false,
        message: action.error,
        messageType: 'error'
      };
    case ADMIN_DETAILS_DELETE_REQUEST:
      return { ...state, loading: true };
    case ADMIN_DETAILS_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        message: 'Success',
        messageType: 'success'
      };
    case ADMIN_DETAILS_DELETE_FAILURE:
      return {
        ...state,
        loading: false,
        message: action.error,
        messageType: 'error'
      };
    case PRODUCT_ACCESS_REQUEST:
      return { ...state, loading: true };
    case PRODUCT_ACCESS_SUCCESS:
      return {
        ...state,
        loading: false,
        productAccessList: action.productAccessList
      };
    case PRODUCT_ACCESS_FAILURE:
      return {
        ...state,
        loading: false
      };
    case UPLOAD_EIN_FILE_REQUEST:
      return {
        ...state,
        loading: true
      };
    case UPLOAD_EIN_FILE_SUCCESS: {
      let list = {};
      if (action.payload.type === 'installer_setup') {
        list = {
          installerSetupErrorList: action.payload.errorList,
          installerSetupSuccessList: action.payload.successList
        };
      } else {
        list = {
          installerUpdateErrorList: action.payload.errorList,
          installerUpdateSuccessList: action.payload.successList
        };
      }
      return {
        ...state,
        loading: false,
        messageType: action.payload.errorList.length > 0 ? 'error' : 'success',
        message: action.payload.message || I18n.t('message.successMessageUpload'),
        ...list
      };
    }
    case UPLOAD_EIN_FILE_FAILURE: {
      let list = {};
      if (action.payload.type === 'installer_setup') {
        list = {
          installerSetupErrorList: action.payload.errorList,
          installerSetupSuccessList: []
        };
      } else {
        list = {
          installerUpdateErrorList: action.payload.errorList,
          installerUpdateSuccessList: []
        };
      }
      return {
        ...state,
        loading: false,
        messageType: 'error',
        message:
          UPLOAD_ERROR_MESSAGE[action.payload.statusCode] ||
          action.payload.statusCode ||
          I18n.t('message.failureMessageUpload'),
        ...list
      };
    }
    case CLEAR_MESSAGE: {
      return {
        ...state,
        messageType: '',
        message: ''
      };
    }
    case PUT_EIN_S3_URL_REQUEST: {
      return {
        ...state,
        loading: true
      };
    }
    case SAMPLE_DATA_REQUEST:
      return { ...state, loading: true };
    case SAMPLE_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        installerSetupHeaders: action.installerSetupHeaders,
        installerUpdateHeaders: action.installerUpdateHeaders
      };
    case SAMPLE_DATA_FAILURE:
      return { ...state, loading: false };
    case UPLOAD_FILE_FAILURE:
      return { ...state, loading: false };
    case GET_ENLM_FEEDBACK_CSV_DATA_REQUEST:
      return { ...state, loading: true };
    case GET_ENLM_FEEDBACK_CSV_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        enlmFeedbacksCsvData: action.enlmFeedbacksCsvData
      };
    case GET_ENLM_FEEDBACK_CSV_DATA_FAILURE:
      return {
        ...state,
        loading: false
      };
    default:
      return state;
  }
}

export default reducer;
